import styled from '@emotion/styled'
import { Card, Grid, Link, Typography } from '@mui/material'
import { navItems } from 'components/purchase/nav-items'
import { PurchaseLayout } from 'hoc/PurchaseLayout'
import { useTranslation } from 'react-i18next'

const breadCrumbItems = [
  {
    id: 'home',
    title: 'Ana səhifə',
    path: '/',
  },
  {
    id: 'contact',
    title: 'Əlaqə',
  },
]

const StyledTypography = styled(Typography)({
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '20px',
  color: '#283a5b',
  '&:hover': {
    color: '#387d71',
  },
})

export const Contact: React.FC = () => {
  const { t } = useTranslation()

  const renderContent = () => {
    return (
      <Card>
        <Typography variant="h5">{t('contact')}</Typography>
        <Grid
          container
          columnSpacing="24px"
          rowSpacing="24px"
          sx={{ marginBottom: '20px' }}
        >
          <Grid item xs={12} md={6}>
            <Typography sx={{ marginBottom: '8px' }} variant="caption">
              {t('address')}:
            </Typography>
            <StyledTypography>
              H.Z. Tağıyev qəsəbəsi, Sumqayıt,Azərbaycan, AZ5022
            </StyledTypography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography sx={{ marginBottom: '8px' }} variant="caption">
              {t('phoneNumber')}:
            </Typography>
            <Link sx={{ textDecoration: 'none' }} href="tel:*0990">
              <StyledTypography>*0990</StyledTypography>
            </Link>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography sx={{ marginBottom: '8px' }} variant="caption">
              {t('email')}:
            </Typography>
            <Link sx={{ textDecoration: 'none' }} href="mailto:info@stp.az">
              <StyledTypography>info@stp.az</StyledTypography>
            </Link>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography sx={{ marginBottom: '8px' }} variant="caption">
              {t('website')}:
            </Typography>
            <Link
              sx={{ textDecoration: 'none' }}
              href="https://stp.az"
              target="_blank"
            >
              <StyledTypography>www.stp.az</StyledTypography>
            </Link>
          </Grid>
        </Grid>
        <iframe
          style={{
            border: 0,
          }}
          width="100%"
          height="450"
          src={
            'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3441.2004198399172!2d49.587192121564534!3d40.60281778234474!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x403097c69d82f6c7%3A0x19577282f8c106e3!2sSumqay%C4%B1t%20Texnologiyalar%20Park%C4%B1%20(STP)!5e0!3m2!1saz!2saz!4v1759835671607!5m2!1saz!2saz'
          }
        ></iframe>
      </Card>
    )
  }

  return (
    <PurchaseLayout breadCrumbItems={breadCrumbItems} content={renderContent()} />
  )
}
